import axiosInstance from '../../../axiosInstance2'
import apiEndpoints from '../../../api'
import { notify } from '../../../../utils/notification'

export const getCountriesReq = (action) => {
    const searchQuery = action?.data || {};
    console.log(searchQuery, 'searchQuery')
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
        search: searchQuery.search || '',
        is_active: searchQuery?.status
    };

    return axiosInstance.get(apiEndpoints.CTRL_GET_COUNTRIES_API, { params })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const getCountryDetailsReq = (action) => {
    const countryId = action?.data?.id || ''
    const url = apiEndpoints.CTRL_GET_COUNTRY_DETAILS_API.replace(':id', countryId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const createCountryReq = (action) => {
    const payload = action?.data || {}
    return axiosInstance.post(apiEndpoints.CTRL_CREATE_COUNTRY_API, payload)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const editCountryReq = (action) => {
    const countryId = action?.data?.id || ''
    let payload = action?.data || {}
    delete payload.id;
    const url = apiEndpoints.CTRL_EDIT_COUNTRY_API.replace(':id', countryId)
    return axiosInstance.put(url, payload)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const deleteCountryReq = (action) => {
    const countryId = action?.data?.id || ''
    const url = apiEndpoints.CTRL_DELETE_COUNTRY_API.replace(':id', countryId)
    return axiosInstance.delete(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}


export const getStatesReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
        search: searchQuery.search || '',
        is_active: searchQuery?.status,
        country_id: searchQuery?.countryId,
    };
    return axiosInstance.get(apiEndpoints.CTRL_GET_STATES_API, { params })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const getStateDetailsReq = (action) => {
    const stateId = action?.data?.id || ''
    const url = apiEndpoints.CTRL_GET_STATE_DETAILS_API.replace(':id', stateId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const createStateReq = (action) => {
    const payload = action?.data || {}
    return axiosInstance.post(apiEndpoints.CTRL_CREATE_STATE_API, payload)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const editStateReq = (action) => {
    const stateId = action?.data?.id || ''
    let payload = action?.data || {}
    delete payload.id;
    const url = apiEndpoints.CTRL_EDIT_STATE_API.replace(':id', stateId)
    return axiosInstance.put(url, payload)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

export const deleteStateReq = (action) => {
    const stateId = action?.data?.id || ''
    const url = apiEndpoints.CTRL_DELETE_STATE_API.replace(':id', stateId)
    return axiosInstance.delete(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}



export const getCitiesReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
        search: searchQuery.search || '',
        is_active: searchQuery?.status,
        state_id: searchQuery?.stateId,
    };

    return axiosInstance.get(apiEndpoints.CTRL_GET_CITIES_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};

/* =========================
   GET CITY DETAILS
========================= */
export const getCityDetailsReq = (action) => {
    const cityId = action?.data?.id || '';
    const url = apiEndpoints.CTRL_GET_CITY_DETAILS_API.replace(':id', cityId);

    return axiosInstance.get(url)
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};

/* =========================
   CREATE CITY
========================= */
export const createCityReq = (action) => {
    const payload = action?.data || {};
    delete payload.country_id;
    return axiosInstance.post(apiEndpoints.CTRL_CREATE_CITY_API, payload)
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};

/* =========================
   EDIT CITY
========================= */
export const editCityReq = (action) => {
    const cityId = action?.data?.id || '';
    let payload = action?.data || {};
    delete payload.id;
    delete payload.country_id;
    const url = apiEndpoints.CTRL_EDIT_CITY_API.replace(':id', cityId);

    return axiosInstance.put(url, payload)
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};

/* =========================
   DELETE CITY
========================= */
export const deleteCityReq = (action) => {
    const cityId = action?.data?.id || '';
    const url = apiEndpoints.CTRL_DELETE_CITY_API.replace(':id', cityId);

    return axiosInstance.delete(url)
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};